/* eslint-disable  react/no-unescaped-entities */
import { Box, Container, Stack, Typography } from '@mui/material';
import React, { Suspense, useEffect, useRef } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styles from './Home.module.scss';
import SkeletonLoader from '../../cms-pages/cms-components/SkeletonLoader/SkeletonLoader';
import BrazeContentCard from '../../components/BrazeContentCard/BrazeContentCard';
import { RouterRoutes } from '../../utils/RouterRoutes';
import PulseSection from './PulseSection/PulseSection';
import { useAuthentication } from '../../contexts/AuthContext';
import { useSeoContext } from '../../contexts/SeoContext';

const MarketingSection = React.lazy(() => import('./MarketingSection/MarketingSection'));
const ApolloWrapper = React.lazy(() => import('../../apolloClient/ApolloWrapper'));

const Home: React.FunctionComponent = () => {
  const blogContainerRef = useRef<HTMLDivElement>(null);
  const { isAuthenticated } = useAuthentication();
  const navigate = useNavigate();

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { setSEO } = useSeoContext()!;

  const canonicalUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}${window.location.pathname}`
      : 'https://www.wonga.co.za/';

  useEffect(() => {
    setSEO({
      canonicalUrl: canonicalUrl,
    });

    if (isAuthenticated) {
      navigate(RouterRoutes.myLoan);
    }
  }, [canonicalUrl, setSEO, isAuthenticated, navigate]);

  return (
    <>
      <BrazeContentCard customPageFeed={RouterRoutes.home} />
      <Container
        disableGutters
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'center',
          marginTop: '4rem',
          marginBottom: '2.5rem',
        }}
      >
        <Outlet></Outlet>
      </Container>

      <PulseSection />

      <Suspense fallback={<SkeletonLoader />}>
        <ApolloWrapper>
          <MarketingSection ref={blogContainerRef} />
        </ApolloWrapper>
      </Suspense>

      <div className={styles['background-wrapper']}>
        <Container
          disableGutters
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: { xs: '4rem', md: '6rem' },
            paddingX: { xs: '4rem', md: '1rem' }
          }}
        >
          <Stack sx={{ gap: 3 }}>
            <Typography variant="h2" textAlign={'center'} fontWeight={400} fontSize={{ xs: '30px', md: '40px' }}>
              We're here to help
            </Typography>
            <Typography variant="h3" textAlign={'center'} fontSize={{ xs: '16px', md: '24px' }}>
              If you've got questions, we've got answers!
              <a className={styles['home-link-cell']} href="/help">
                {' '}
                {' Visit our FAQs '}
              </a>
            </Typography>
          </Stack>
        </Container>
      </div>
    </>
  );
};

export default Home;
